import * as React from 'react';
import { observer } from 'mobx-react';

// Types
import { ITag } from './AppNetworkPeopleMyTags';

// Components
import Box from '../../components/Box';
import Icon from '../../components/Icon';
import IconButton from '../../components/IconButton';
import { CircularProgress } from '../../components/Progress';
import Table, { TableBody, TableCell, TableRow } from '../../components/Table';

// Component
interface IProps {
  tags: ITag[] | null;
  onTagRemove: (tagId: string) => void;
}

function TagTable(props: IProps) {
  if (props.tags === null) {
    return (
      <Box pa={5} align="center">
        <CircularProgress />
      </Box>
    );
  }
  return (
      <Table>
        <TableBody>
          {props.tags.map(item => (
            <TableRow key={item.tagId}>
              <TableCell>{item.pathName}</TableCell>
              <TableCell padding={'none'} numeric={true}>
                <IconButton onClick={() => props.onTagRemove(item.tagId)}>
                  <Icon>delete</Icon>
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
  );
}

export default observer(TagTable);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleMyTags/TagTable.tsx